var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIBotNav04({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4579 4C14.1884 4 12.9853 4.44526 12 5.26947C11.0242 4.44526 9.82105 4 8.54211 4C5.49158 4 3 6.61474 3 9.81684C3 10.7263 3.19895 11.5979 3.58737 12.4221C3.58737 12.4221 3.58737 12.4411 3.59684 12.4505C3.65368 12.5926 5.15053 16.06 11.6021 20.4653C11.7253 20.5505 11.8579 20.5884 12 20.5884C12.1421 20.5884 12.2842 20.5505 12.3979 20.4653C18.8495 16.06 20.3368 12.6021 20.4032 12.4505C20.4032 12.4505 20.4032 12.4316 20.4126 12.4221C20.8011 11.6074 21 10.7358 21 9.81684C21 6.60526 18.5084 4 15.4579 4ZM12.9189 16.96H11.0905V11.0958H12.9189V16.96ZM13.2032 8.90737C13.2032 9.53263 12.7011 10.0347 12.0758 10.0347H11.9147C11.2895 10.0347 10.7874 9.53263 10.7874 8.90737V8.74632C10.7874 8.12105 11.2895 7.61895 11.9147 7.61895H12.0758C12.7011 7.61895 13.2032 8.12105 13.2032 8.74632V8.90737Z",
    fill: "#5697FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBotNav04);
export default __webpack_public_path__ + "static/media/i_bot_nav_04.736f558d44ad6c40967455d3e2a8de36.svg";
export { ForwardRef as ReactComponent };